module.exports = __webpack_public_path__ + "static/media/S21-1827_$1_Coffee_HomePage_Banners_2396x1473_BC_FR.da310605.jpg";